import Cookies from "js-cookie";
import authConfig from "@/config/auth";

export function forceLogout() {
  Cookies.remove(authConfig.JWT_TOKEN_COOKIE);
  Cookies.remove(authConfig.ACCESS_TOKEN_COOKIE);
  Cookies.remove("user");
  localStorage.removeItem("token");
  localStorage.removeItem("ComId");
  localStorage.removeItem("user");
  localStorage.removeItem("loginTime");
  window.location.replace("/");
}
